/**
 * description: 微博撤稿-撤稿原因弹窗
 * author: Qian.qianchen 2018-11-20
 */
'use strict';
angular.module('weiboWithdrawModule', []).controller('weiboWithdrawCtrl', [
    '$scope',
    '$modalInstance',
    'itemArr',
    '$validation',
    'weiboApiParams',
    'weiboApiService',
    function($scope, $modalInstance, itemArr, $validation, weiboApiParams, weiboApiService) {
        initStatus();

        /**
         * [initStatus 初始化状态]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
            };
            $scope.data = {
                reasonContent: '',
            };
        }

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        
        /**
         * [confirm description] 表单信息提交-确认
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            $scope.reasonForm.$pending = {};
            $validation.validate($scope.reasonForm).success(function() {
                let params = angular.extend({}, weiboApiParams.withDrawParams, {
                    ObjectIds: itemArr
                        .map(function(item) {
                            return item.SCMMICROCONTENTID;
                        })
                        .join(','),
                });
                params.content = $scope.data.reasonContent;
                $scope.loadingPromise = weiboApiService.withDraw(params).then(
                    function(data) {
                        $modalInstance.close(data);
                    }
                );
            });
        };
    },
]);
